import type { ISiteSettings } from '@sravni/types/lib/sitesettings';

import type { GlobalState } from '../index';

export const getSiteSettings = (state: GlobalState): ISiteSettings => state.sitesettings;
